import { Link } from "react-router";
import translate from "../locales";

export function NextStatements({ content }) {
  return (
    <>
      {content.settings.availableStatements.map((key) => (
        <Link to={`../${key}`} key={key} className="link-card">
          {translate(["statements", key, "name"])}
        </Link>
      ))}
    </>
  );
}
